'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _compose = require('./compose');

var ADD_COMMENT_EVENT = 'bc.addComment';
var EDIT_COMMENT_EVENT = 'bc.editComment';
var REMOVE_COMMENT_EVENT = 'bc.removeComment';
var ADD_COMMENT_ACTION = 'v2-add';
var EDIT_COMMENT_ACTION = 'v2-edit';
var REMOVE_COMMENT_ACTION = 'v2-remove';
var COMMENTS_GTM_CATEGORY = 'v2-comments';

function composeCommentEvent(eventName, action) {
  return (0, _compose.composeEvent)(eventName, {
    gtmValue: 1,
    gtmLabel: undefined,
    gtmCategory: COMMENTS_GTM_CATEGORY,
    gtmAction: action
  });
}

function composeAddCommentEvent() {
  return (0, _compose.composeAnalytics)([composeCommentEvent(ADD_COMMENT_EVENT, ADD_COMMENT_ACTION)]);
}

function composeEditCommentEvent() {
  return (0, _compose.composeAnalytics)([composeCommentEvent(EDIT_COMMENT_EVENT, EDIT_COMMENT_ACTION)]);
}

function composeRemoveCommentEvent() {
  return (0, _compose.composeAnalytics)([composeCommentEvent(REMOVE_COMMENT_EVENT, REMOVE_COMMENT_ACTION)]);
}

exports.default = {
  composeAddCommentEvent: composeAddCommentEvent,
  composeEditCommentEvent: composeEditCommentEvent,
  composeRemoveCommentEvent: composeRemoveCommentEvent,
  ADD_COMMENT_EVENT: ADD_COMMENT_EVENT,
  EDIT_COMMENT_EVENT: EDIT_COMMENT_EVENT,
  REMOVE_COMMENT_EVENT: REMOVE_COMMENT_EVENT,
  ADD_COMMENT_ACTION: ADD_COMMENT_ACTION,
  EDIT_COMMENT_ACTION: EDIT_COMMENT_ACTION,
  REMOVE_COMMENT_ACTION: REMOVE_COMMENT_ACTION,
  COMMENTS_GTM_CATEGORY: COMMENTS_GTM_CATEGORY
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/commentsEventComposer.js
// module id = 552
// module chunks = 0 2 4 6 7 8 9 10